/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("authenticationModule", [
    "authenticationRouter", //路由
]).
controller("authenticationCtrl", ["$scope", '$rootScope', "$stateParams", "httpService", "$state", '$validation', '$element', function($scope, $rootScope, $stateParams, httpService, $state, $validation, $element) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.info = {
            sex: 0,
        };
        $scope.data = {
            listData: [],
            errName: false, //真是姓名
            errBackCard: false, //银行卡号
            errEmail: false, //邮箱可否使用
        };
        // $scope.parentParams = JSON.parse($stateParams.info);
        $scope.parentParams = $rootScope.informationRetained;
        initDropDownList();
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {

    }
    /**
     * [initDropDownList description] 初始下拉
     */
    function initDropDownList() {
        $scope.status.bankOptions = [{
            name: "选择开户银行",
            value: 0
        }, {
            name: "工商银行",
            value: 1,
        }, {
            name: "农业银行",
            value: 2,
        }, {
            name: "中国银行",
            value: 3,
        }, {
            name: "建设银行",
            value: 4,
        }, {
            name: "交通银行",
            value: 5,
        }, {
            name: "上海浦东发展银行",
            value: 6,
        }, {
            name: "兴业银行",
            value: 7,
        }, {
            name: "光大银行",
            value: 8,
        }, {
            name: "深圳发展银行",
            value: 9,
        }, {
            name: "民生银行",
            value: 10,
        }, {
            name: "中信银行",
            value: 11,
        }, {
            name: "招商银行",
            value: 12,
        }, {
            name: "广东发展银行",
            value: 13,
        }, {
            name: "华夏银行",
            value: 14,
        }];
        $scope.status.selectedBank = angular.copy($scope.status.bankOptions[0]);
        $scope.status.selectedBank.name = '请选择开户银行';
    }
    /**
     * [funciton description] 下拉框加样式
     * @return {[type]} [description]
     */
    $scope.selectData = function(key) {
        key.value == 0 ? $element.find('trs-single-select button span:first-child').removeClass('textColor') : $element.find('trs-single-select button span:first-child').addClass('textColor');
    };
    /**
     * [choseSex description]性别
     */
    $scope.choseSex = function(value) {
        $scope.info.sex = value;
    };
    /**
     * [choseSex description]性别
     */
    $scope.savePwd = function() {
        $validation.validate($scope.changePwdForm).success(function() {
            // $scope.params.push($scope.info);
            if (!$scope.isShowTipsB && $scope.data.errEmail) {
                $element.find('.emailIntercept').focus();
                return;
            }
            $scope.info.bankName = $scope.status.selectedBank.value;
            var params = $.extend($scope.parentParams, $scope.info);
            httpService.http("/mcnww/web/user/register.do", params, "post").then(function(result) {
                $rootScope.informationRetained = '';
                if(result.success){
                    sessionStorage.setItem("requestToken", result.requestToken);
                }
                $state.go("register.success");
            });
        }).error(function() {
            angular.invalidPosition($scope.changePwdForm, $element);
        });

    };
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //真实姓名
                $scope.isShowTipsA = false;
                $scope.data.isShowTipsAa = false;
                var uesrLength = $element.find('.table>ul>li:first-child>.tips');
                uesrLength.text().length > 10 ? uesrLength.addClass('notPaddintTop') : uesrLength.removeClass('notPaddintTop');
                break;
            case 2: //邮箱
                $scope.isShowTipsB = false;
                $scope.data.isShowTipsBb = false;
                $scope.data.errEmail = false;
                break;
            case 3: //单位名称
                $scope.isShowTipsC = false;
                $scope.data.isShowTipsCc = false;
                break;
            case 4: //所在地址
                $scope.isShowTipsD = false;
                $scope.data.isShowTipsDd = false;
                break;
            case 5: //银行卡号
                $scope.isShowTipsF = false;
                $scope.data.isShowTipsFf = false;
                break;
            case 6: //支付宝帐号
                $scope.isShowTipsG = false;
                $scope.data.isShowTipsGg = false;
        }
        $validation.validate($scope.changePwdForm[value]).success(function() {
            switch (key) {
                case 1:
                    $scope.data.isShowTipsAa = true;

                    if (codeNum($scope.info.truename) >= 4 && codeNum($scope.info.truename) <= 20) {
                        $scope.data.isShowTipsAa = true;
                    } else {
                        $scope.data.errName = true;
                    }

                    if (codeNum($scope.info.truename) >= 4 && codeNum($scope.info.truename) <= 20) {
                        $scope.data.isShowTipsAa = true;
                    } else {
                        $scope.data.errName = true;
                    }
                    break;
                case 2:
                    if (/\S/.test($scope.info.email) && $scope.info.email != undefined) {
                        httpService.http('/mcnww/web/user/existsValid.do', { name: 'email', param: $scope.info.email }, 'post').then(function(data) {
                            if (data.status == 'y') {
                                // errEmail
                                $scope.data.isShowTipsBb = true;
                            } else {
                                $scope.data.errEmail = true;
                            }
                        });
                    } else {
                        $scope.data.isShowTipsBb = true;
                    }
                    break;
                case 3:
                    $scope.data.isShowTipsCc = true;
                    break;
                case 4:
                    $scope.data.isShowTipsDd = true;
                    break;
                case 5:
                    $scope.data.isShowTipsFf = true;
                    break;
                case 6:
                    $scope.data.isShowTipsGg = true;
                    break;
            }
        });
    };
    /**
     * [codeNum description] 判断多少个数
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    function codeNum(value) {
        var reg = /[\u4E00-\u9FA5]/;
        var quantity = 0;
        for (var i in value) {
            reg.test(value[i]) ? quantity += 2 : quantity += 1;
        }
        return quantity;
    }
    /**
     * [lastStep description]  上一步
     * @param  {[type]}   [description]
     */
    $scope.lastStep = function() {
        $state.go("register.basicinformation", $stateParams);
    };

}]);